import { useState } from "react"
import "./App.css"
import { LoadingScreen } from "./LoadingScreen"
import { LoginScreen } from "./LoginScreen"
import { DataScreen } from "./DataScreen"
import { User } from "./api"

export enum Screen {
  Loading = "Loading",
  Login = "Login",
  Data = "Data",
}

export const App = () => {
  const [screen, setScreen] = useState(Screen.Loading)
  const [loggedInUser, setLoggedInUser] = useState<User>()

  return (
    <div className="App">
      {screen === Screen.Loading && (
        <LoadingScreen
          onNotLoggedIn={() => {
            setScreen(Screen.Login)
          }}
          onLoggedIn={(loggedInUser) => {
            setLoggedInUser(loggedInUser)
            setScreen(Screen.Data)
          }}
        />
      )}
      {screen === Screen.Login && (
        <LoginScreen
          onLoggedIn={(loggedInUser) => {
            setLoggedInUser(loggedInUser)
            setScreen(Screen.Data)
          }}
        />
      )}
      {screen === Screen.Data && (
        <DataScreen
          loggedInUser={loggedInUser!}
          onLoggedOut={() => {
            setLoggedInUser(undefined)
            setScreen(Screen.Login)
          }}
        />
      )}
    </div>
  )
}
